// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSerif_a46688', '__fedraSerif_Fallback_a46688'"},"className":"__className_a46688","variable":"__variable_a46688"};